module.exports = __webpack_public_path__ + "static/media/readiness-play-blue-icon.b71827f8.svg";